import React from "react";
import { SearchOutlined, } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card } from "antd";



const Search = ({ dispatch, searchLoading }) => {
    const [form] = Form.useForm();


    const searchClickHandler = () => {
        const filter_click = {
            type: "set_clicked",
            payload: true,
        };
        dispatch(filter_click);

        const requestFilters = {
            title: form.getFieldValue("title") ? form.getFieldValue("title") : null,
        };

        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card>
                    <Form
                        layout="vertical"
                        labelAlign="left"
                        form={form}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={24} align="bottom">
                            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item name="title" label="Titulli:" className="mb-0">
                                    <Input
                                        name="title"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={4} lg={4} md={4} sm={24} xs={24} className="text-center mb-0">
                                <Button
                                    type="primary"
                                    size="medium"
                                    loading={searchLoading}
                                    icon={<SearchOutlined />}
                                    onClick={() => searchClickHandler()}
                                >
                                    Kërko
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};


export default Search;